import { render, staticRenderFns } from "./blok-table.vue?vue&type=template&id=97fa7954&scoped=true&"
import script from "./blok-table.vue?vue&type=script&lang=js&"
export * from "./blok-table.vue?vue&type=script&lang=js&"
import style0 from "./blok-table.vue?vue&type=style&index=0&id=97fa7954&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97fa7954",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97fa7954')) {
      api.createRecord('97fa7954', component.options)
    } else {
      api.reload('97fa7954', component.options)
    }
    module.hot.accept("./blok-table.vue?vue&type=template&id=97fa7954&scoped=true&", function () {
      api.rerender('97fa7954', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/blok/blok-table.vue"
export default component.exports